/*@ngInject*/
const TypeAheadFilterController = function ($scope, $q, $element, advancedFilterModel, coreConstant,
                                            coreMediator, submissionConstant, localization, dataSetUtil) {

    this.$onInit = function () {
        let criterionTemplate = this.criterionTemplate,
            dataSetName = criterionTemplate.dataSetName,
            submissionUri = !_.isNil(this.submissionId) ? 'com.firstbest.underwriting.submission.Submission:' + this.submissionId : null,
            variableName = criterionTemplate.variableName,
            dataSetParams = dataSetUtil.getDataSetParamsByName(dataSetName, variableName, submissionUri);

        this.searchDelayInMilliSeconds = submissionConstant.searchDelay;

        this.itemsList = [];
        this.isOpen = true;

        localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then((translations) => {
            this.placeholder = _.get(translations.typeAheadFilter, this.criterionTemplate.variableName + '.placeholder') || translations.placeholder;
        });

        return dataSetUtil.getDataItems(dataSetParams).then(function (items) {
            if (!_.isNil(items)) {
                _.each(items, function (item) {
                    if (item && item.isDefault) {
                        this.criterionTemplate.value = item.name;
                    }
                }.bind(this));
                $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType, true);
                this.setItemsList(items);
                return items;
            }
        }.bind(this));
    };

    this.setItemsList = function (itemsList) {
        this.itemsList = itemsList;
        this.filterItems();
    };

    this.filterItems = function (searchText) {
        let filteredItemsList = [];

        if (!_.isEmpty(searchText)) {
            filteredItemsList = _.filter(this.itemsList, function (item) {
                return _.includes(_.toLower(item.name), _.toLower(searchText));
            });
        } else if (_.isArray(this.itemsList)) {
            filteredItemsList = this.itemsList;
        }

        if (this.searchableList && filteredItemsList.length > 150) {
            this.showLongListWarning(filteredItemsList.length);
        } else {
            this.filteredItemsList = filteredItemsList;
        }
    };

    this.handleChange = function () {
        if (!_.isNil(this.criterionTemplate.value) && !_.isNil(this.criterionTemplate.value.name)) {
            this.criterionTemplate.value = this.criterionTemplate.value.name;
        }
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
    };

    this.getComponentId = function (filterCriterionTemplate) {
        return this.advancedFilterType + 'AdvancedFilterType ' + filterCriterionTemplate.variableName;
    };

    this.handleRemove = function () {
        advancedFilterModel.unselectFilterCriterion(this.advancedFilterType, this.criterionTemplate.id);
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
    };

    $scope.$on(coreConstant.event.FILTER_CLEARED, function (event, criterionTemplateId) {
        if (criterionTemplateId === this.criterionTemplate.id) {
            this.criterionTemplate.value = '';
        }
    }.bind(this));
};

angular.module('umCore')
    .controller('typeAheadFilterController', TypeAheadFilterController);
